// extracted by mini-css-extract-plugin
module.exports = {"Legend":"Legend_Legend__2yHoZ","Bin":"Legend_Bin__2pAz4","Label":"Legend_Label__2ToCJ","Colour":"Legend_Colour__34tQD"};